module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAZklEQVQ4T+2UXQoAIQiEnWste/3ONUsPQgWmgbBQ9Wj6+TMiJPmh5ZEsIvIs5igAXo0ZgQTQ2Tw4yS7GBFbHCvMSbAT0Zqf/4ZbTgSqKBVax/qvwtmxOICzKgSpnrU3ugY1WNfP7AAuMohVCsXjJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/notes.png
// module id = Gxgs
// module chunks = 1